


















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import moment = require('moment');
@Component({
  name: 'ui-minutes',
})
export default class UiMinutes extends Vue {
  @Prop({ default: new Date(), type: Date })
  date: Date;

  innerMinutes: any = [];
  innerMonth = this.date.getMonth();
  innerYear = this.date.getFullYear();
  innerDay = this.date.getDate();
  innerHour = this.date.getHours();
  innerMinute = this.date.getMinutes();

  mounted() {
    this.setHour(this.date);
    this.setMinutes();
  }

  // getMonths() {
  //   return this.months.map(function(item, index) {
  //     return { number: index, name: item };
  //   });
  // }

  setMinutes() {
    this.innerMinutes = [];
    for (let index = 0; index < 60; index += 5) {
      this.innerMinutes.push({
        name:
          this.innerHour +
          ':' +
          index.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false,
          }),
        number: index,
        type: Number(this.innerMinute) == index ? 'current' : '',
      });
    }
  }
  getHourName() {
    let hourNames = [' час', ' часа', ' часов'];
    let n = Math.abs(this.innerHour) % 100;
    let n1 = n % 10;
    if (n > 10 && n < 20) {
      return this.innerHour + hourNames[2];
    }
    if (n1 > 1 && n1 < 5) {
      return this.innerHour + hourNames[1];
    }
    if (n1 == 1) {
      return this.innerHour + hourNames[0];
    }
    return this.innerHour + hourNames[2];
  }

  setHour(date: Date) {
    this.innerHour = date.getHours();
  }
  next() {
    this.setHour(new Date(this.innerYear, this.innerMonth, this.innerDay, this.innerHour + 1));
    this.setMinutes();
  }
  backward() {
    this.setHour(new Date(this.innerYear, this.innerMonth, this.innerDay, this.innerHour - 1));
    this.setMinutes();
  }
  changeMinute(minute: any) {
    this.clearMinutes();
    minute.type = 'current';
    this.$emit('changeMinute', new Date(this.innerYear, this.innerMonth, this.innerDay, this.innerHour, minute.number));
  }
  changeHours() {
    this.$emit('onNavigation');
  }
  clearMinutes() {
    for (let index = 0; index < this.innerMinutes.length; index++) {
      if (this.innerMinutes[index].type == 'current') {
        this.innerMinutes[index].type = '';
      }
    }
  }
  openDays() {
    this.$emit('changeCurrentView', 'days');
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-date-picker/src/ui-minutes.vue